import React from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import { RenderInput } from "../Common/InputComponents/Inputs";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as assayActions from "../../actions/assays";
import { minLength5,required } from "../../util/validations";
import {removeSpaces} from "../../util/format"
import _ from 'underscore';
class AssayName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pencilClicked: false,
    };
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({ pencilClicked: true });
  };

  render() {
    const { pencilClicked } = this.state;
    const {
      name,
      canOverrideAssayName,
      actions,
      handleSubmit,
      reset,
      editableUserName,
      formObj,
      pristine,
      submitting
    } = this.props;
    const syncErrors = formObj && formObj.syncErrors || {}
    return (
      <div className="col-8 container-fluid">
        {/* Normal case where canOverrideAssayName is false*/}
        {!canOverrideAssayName && <span>{name}</span>}

        {/* Case where the canOverrideAssayName is true  */}

        {canOverrideAssayName && !pencilClicked && (
          <div>
            <span>{editableUserName || ""}</span>
            <i onClick={this.handleClick} className="fas fa-pencil-alt"></i>
          </div>
        )}

        {canOverrideAssayName && pencilClicked && (
          <div className="row">
            <div className="col-4">
              <Field
                name="assayName"
                placeholder="Enter Assay Name"
                className="form-control"
                type="text"
                component={RenderInput}
                validate={[minLength5,required]}
                normalize={removeSpaces}
              />
            </div>

            <div className="col-2 d-flex justify-content-around">
              <button
              disabled={
                (pristine || submitting|| !_.isEmpty(syncErrors))
              }
                onClick={() => {
                  handleSubmit();
                  this.setState({ pencilClicked: false });
                }}
                type="submit"
                className="btn btn-success action-buttons"
              >
                <span className="fa fa-check"></span>
              </button>
              <button className="action-buttons"
                onClick={() => {
                  reset();
                  this.setState({ pencilClicked: false });
                }}
                type="button"
              >
                <span className="fa fa-times"></span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const stateToProps = (state, props) => ({
  formObj: state.form["frmAssayName"],
  initialValues: {
    assayName: props.editableUserName || "",
    assayCommercialId: props.assayCommercialId,
    uniqueUuidId: props.uniqueUuidId || "",
  },
});

const onSubmit = (values, dispatch) => {
  dispatch(assayActions.setAssayName(values));
};

AssayName = reduxForm({
  form: "frmAssayName",
  enableReinitialize: true,
  onSubmit,
})(AssayName);

AssayName = connect(stateToProps, {})(AssayName);

export default AssayName;
